module.exports = __webpack_public_path__ + "img/DC-Logo-Web-White.57debff.png";